import React, { useCallback, useEffect, useState } from "react";
import Layout from "@/Components/layout/Layout";
import { Link, useParams } from "react-router-dom";
import { getBusinesss } from "@/utils";
import { DEFAULT_TYPE_ICONS } from "@/constants";
const staticRecords = [
  {
    name: "1028 Flying Club, LLC",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "184 Flying Club, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "20 Awesome, LLC",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "21 Flyers Inc",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "2M2 Flying Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "3 Amigos Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "3 Rivers Taildraggers Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "3B0 Flying Club (Club In Formation)",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "43rd Aviation Flying Club",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "44 Flyers",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "4DY Flying Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "51st Aero Squadron, LLC",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "7B Flying Club, Inc.",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "7KiloMike",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "81 Escadrille, Inc.",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "907th Flight Squadron",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "908 Flying Club, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "A&E Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "A.M. Light Sport",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "AAA Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "ABC Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Acanthis (Greek Goddess of Birds) Aviation",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Access Aero Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Access Flying Club (Club In Formation)",
    state: "Alaska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ace Flight Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Acorn Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Acorn Mutual Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Adirondack Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Adirondack Soaring Association",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "ADK Flying Club, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Adrian Soaring Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Adventure Flight Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Valkaria LLC",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Association of Caltech (AACIT)",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Club 7",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Club Albatross",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Club de Puerto Rico",
    state: "Puerto Rico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Club of Enid",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Club of Houston",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Club of Pennsylvania",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Dynamics Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Fliers, Inc",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Head Soaring Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "AERO NORTHWEST LLC",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Soaring Club, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aero Valkaria LLC",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "AeroFlyte of Pomona, Inc",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aerovalley Flying Club, Inc",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "AeroVentures Flying Club, Inc.",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Air Capital Aviators Club",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Air Coeur",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Air Coeur Flying Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Air Group",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Air Tech Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Air.Spacers Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aircrafters French Valley Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Airhawks Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Airheads Flying Club",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Airlake Aero, Inc.",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "AirTime Flying Club LLC",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Airway Aviation",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aksarben Flying Club",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Alameda Aero Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Alameda Flying Club, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Alamo City Flying Pilots Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Albany Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Albuquerque Soaring Club",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Alexandria Flying Club, Inc.",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Alleghany Flying Club",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Alman Bonanza Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Altamira Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Alto Vista Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "American Aero Club",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "American Flight Club",
    state: "Nevada",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "American Light Flyers, Inc.",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "ANG Aero Club, Inc",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Angel's Wings El Paso",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Angle of Attack",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ann Arbor Flyers",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Anson Flying Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Antelope Valley Soaring Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Apollo Flying Club",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Arctic Flying Club",
    state: "Alaska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Arizona Cloudbusters, Inc.",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Arizona Flyers Club, Inc.",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Arlington Flyers Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Armed Forces Aero Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Artisan Aviation, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "ASB Flyers Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ascension Air",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ascension Air",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Associated Glider Clubs of Southern California",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Associated Pilots, Inc",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Athens Aero Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Athol",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Atlanta Aviators",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Atlanta Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Atlantic Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Atlantic Soaring Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Augusta Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aurora Flying club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aurora Flying Club",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Austin Aviators Flight Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Austin Light Sport",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Austin Mooney Flyers, LLC",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "AV8IR",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ava Aviation Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aviation Access Rome",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Aviation Explorer Post 8",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Back 40 Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Back to Basics",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Badger Aviators",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Badgerland Aero Club, Inc",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Baja Flyers",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bakalar Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bald Eagle Aviation Club",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bald Eagle Flying Club",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Batavia Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bates Field Aero Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bates Field Aero Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bay Area Aero Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bay Area Soaring Associates",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bay de Noc Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Beaver Valley Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Beech Aero Club of Frederick",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Beech Flyers",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "BeechClub.org",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bell Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bell Ornithopters Flying Club Inc.",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bemidji Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "BFC Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Big Bend Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Big M Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "BiPlane Training LLC",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "BK Inc Twin Rentals",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Black Forest Soaring Society",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Black Hills Soaring Club, Inc.",
    state: "South Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Black Hole, Inc",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blackhawk Flying Club, Inc.",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blackhawk Soaring Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bloomsburg Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Horizons Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Max Aero Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Ridge Flyers",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Ridge Soaring Society",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Skies Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Skies Flying Club, LLC",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Sky Aviation Association",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Sky Flyers Flying Club",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Sky Flying Club, LLC",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Sky Guys",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Blue Valley Flying Club",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bluebird Aero Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Boca Raton Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Boeing Employees' Flying Association",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Boulder Flying Club",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bowman Eagles, Inc.",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Boyertown Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bradley Flying Association",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brandywine Flyers, LLC",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brandywine Soaring Association",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Braxton Flying Club",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brewer Flying Club, Inc.",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bridge City Flyers",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brighton Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brockton Flying Club",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brokenstraw Soaring Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brown County Flying Club",
    state: "South Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Brown Flying Club",
    state: "Rhode Island",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Buena Vista Flying Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Buffalo Flying Club",
    state: "North Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Bulldog Aviation Club",
    state: "Mississippi",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Butler Fly Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "C&B Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "CAE Flying Club of Ohio",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Caesar Creek Soaring Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Camas Washougal Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Camden Flying Club (Club In Formation)",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Candler Field Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cane River Flying Club",
    state: "Louisiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cantrall Aviation Flying Club",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "CAP Flying Association Inc.",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cape Cod Aero Club, LLC",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cape Fear Flying Club, Inc",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Capitol City Flyers,Inc.",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Capper Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Caprock Soaring Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Carbon Flyers",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Carlisle Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Carolina Soaring Association",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Carrabelle Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cascade Flyers, Inc.",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cascade Soaring Society",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cattaraugus Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "CAVU Flyers of Long Island, Inc",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "CAVU Flying Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Centerline Flying Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Alabama Soaring Association",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Arkansas Flying Club",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central California Soaring Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Illinois Aviators",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Kentucky Flying Club, Inc.",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Maine Regional Flying Club",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Mississippi Light Flyers, Inc.",
    state: "Mississippi",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Mississippi Soaring Society",
    state: "Mississippi",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Ohio Flyers Association",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Oklahoma Aviators Flying Club",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Oklahoma Aviators Flying Club",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Valley Aviation Association",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Virginia Flyers",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Virginia Flyers",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Central Virginia Flyers",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cereal City Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chandelle Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Channel City Flyers",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chapter 15 Aviation",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chapter 36 Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cherokee Flying Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cherokee Pilots LLC",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cherokee Quad Squad",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chesapeake Skyhawks",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chester Light Fliers",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chewelah Flyers, Inc.",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cheyenne Flying Club",
    state: "Wyoming",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chico Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chief Joseph Flyers",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chiques Aero Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Chuckanut Flying Clu",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Circle W Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cirrus Eagles LLC",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Civil Aviation, Inc",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Clear Lake Flying Club In Formation",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Clear Skies Flying Club, LLC",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Clearview Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Clearwater Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Clearwater Valley Aero Club, Inc.",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Clemson Flying Club",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cleveland Soaring Society, Inc.",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cloud Cappers",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cloud Chasers, Inc.",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cloud Dodgers Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cloud Niners, Inc.",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cloud One Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cloudhoppers Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club AV8",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club Cherokee",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation (Flying Manatees Aviation Club)",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation (KBST)",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club In Formation (KEUG)",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation (Merrill Field Flyers)",
    state: "Alaska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation",
    state: "North Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation: Chester County Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation: Frederick Gyronauts",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation: Maryland Aces Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation: Mid",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation: No Cents Flying Club",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation: Prairie Aire Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club in Formation: Wings Over West",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Club Takeoff",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Colonial Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Colorado Soaring Association",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Columbia Flight Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Comal Aero, Inc.",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Concord Cessna Fliers",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Concord Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Condair Flyers, Inc",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Condor Aero Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Congressional Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Connecticut Flight Club, Inc.",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Connecticut Flyers, Inc.",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Connecticut Soaring Association",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Connecticut Valley Flyers",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Connellsville Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Connersville Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Continental SkyLarks",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cooperative Crossroads Flying Club",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Country Flying Educational Association Inc.",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cowtown Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cross Country Aircraft Club of Colorado Springs",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cross Country Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Crosswinds Flying Club, Inc.",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Crow Wing Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cumberland Soaring Group",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "CW Flyers",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "CXO Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cynthiana Flying Group",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Cypress Soaring Glider Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dakota Group",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dal.Tex Flyers",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Daniel Boone Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dawn Patrol Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dayton Pilots Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Daytona Beach Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "DC Diamond Pilots (Club In Formation)",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dearborn Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Decatur Aero Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Deer Valley Skyhawks",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Del Amo Flyers",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Del.Penn Flyers, Inc",
    state: "Delaware",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Delaware Coastal Flying Club",
    state: "Delaware",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Delaware Flyers",
    state: "Delaware",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Delaware Valley Aviation",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Delta Aviation Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Delta Bravo Aviation",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Delta Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Denver Flyers",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Des Moines Flying Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Deschutes Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Desert Sport Flyers",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Destinations Flight Club, LLC",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Detroit Tuskegee Airmen Glider Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Diamond Valley Aviators",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Discover Aviation Center Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Discovery Aviation Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Double K Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Downwind Corp",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Downwind Flying Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Downwind Pilots Association",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Draggin Tail Pilots",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dunedin Flying Club INC",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dust Devil Flying Club",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Dusty Wings Flying Club",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eagle Air Flying Club, Inc.",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eagle Air Inc",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eagle Flying Club of Embry",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eagle Squadron, Inc",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "East Coast Tomahawk Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "East Tennessee Pilots Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eastern Idaho Flying Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eastern Iowa Heartland Flyers Flight Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "ECG Flying Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Echo 4 Flying Club, Inc",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eight Ball Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Elk Flyers",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Elk Mountain Soaring",
    state: "Utah",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Elkhart Wings",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Emporia Flying Club",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "EnginAires Aero Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Evergreen Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Evergreen Soaring, Inc.",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "EVV Pilots Club, Inc",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Executive Aero Flight Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eximious Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Eximious Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "F & W Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "FAA Flying Club of Washington DC",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fairmont Flying Club Inc.",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Falcon Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Falcon Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Falcon Flying Club, Inc.",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fallbrook Aero Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Father John Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Faultline Flyers",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fayette Regional Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fayetteville Flying Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Feet Wet Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "FFC, LLC",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "FFF Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Finger Lakes Soaring Club, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fingerlakes Area Pilots, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Firelands Aero Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fish Creek Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flaps Inc",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flatlanders Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fliegend Inc.",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flight Club 502, Inc.",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flight Club Spinks Squadron",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flight Inc.",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flighttime Inc.",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Florida Aero Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Florida Best Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Florida Chapter Short Wing Piper Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Florida Gulf Coast University Aviation Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "FLY OZ Club",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying 20 Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying 20 Club, Inc.",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Bald Eagles, Inc.",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Broke Acres",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Club of Kansas City",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Club, Miami University",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Country Club, Inc",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Educators Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Engineers, INC.",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Five, Inc.",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Gators",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Hawks Inc",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Particles, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Rangers Flying Club",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Ten Flying Club",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Twenty, Inc",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flying Veterans Club, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "FlyMe2",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flymore",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "FlySRQ, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Flywell Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "flywyld Aviators, Inc.",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Forbes Aero Club",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ford Eagles Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fort Myers Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fort Sam Houston Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fort Smith Flying Club",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fort Worth Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Four Five November, LLC",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "FourTenFlyers",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fox Valley Aero Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fox Valley Flyers, Inc.",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fox Valley Flying Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Franconia Soaring Association",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Franklin County Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Franklin County Flying Club",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Frederick Aero Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fredericksburg Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Free State Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Freedom Flyers",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Freedom Wings International",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Freeport Flyers, Inc.",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Frontier Flyers (Club in Formation)",
    state: "Wyoming",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fruit Belt Flyers Inc",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fubar Flyers, Inc",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fullerton Junior Aviators",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fulton Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fun Country Soaring",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Fun Country Soaring Club, Inc.",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "G.A.C.E Flying club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "G.P.A. Aviation Club, Inc.",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gainesville LSA (Club In Formation)",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gamecock Flight Club",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gastonia Aero Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gateway Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gateway Tailwheel Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "GAW (Get A Way) Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Geauga Aviators Flying Club, Inc",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Generations Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "George Downer Flyers",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Georgia Aviation Association, Inc",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gift of Flight, Inc NFP",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gig Harbor Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gnoss Field Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Goddard Aircraft Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gold Beach Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Golden Hour Flight Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Golden Wings Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gone Broke LLC",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gopher Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Grand Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Grand Teton Soaring Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Grasshopper Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Grassroots Flying Omaha",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Greater Flint Pilots Association",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Greater Houston Soaring Association, Inc.",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Greene County Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Greylock Flying Club, Inc.",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gulf Shores Flying Club, Inc",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Gville Flyers, LLC",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hagerstown Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Half Moon Bay Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hamilton Soaring Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "HAMMOND FLYING CLUB",
    state: "Louisiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hangar 10",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Happy Bottom Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Happy Goat Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Happy Landings LLC",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hardrocker Flying Club",
    state: "South Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Harford Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Harrah Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Harrier Soaring",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Harris Hill Soaring Corporation",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Harrison Social Flites Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Harry's Hawks",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Havre Flying Club",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hawaii Flying Club",
    state: "Hawaii",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hawk Flying Club",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hawk Valley Soaring Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hawks Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hedgehoppers Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hemacinto Valley Flying Club, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Henniker Flying Club",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "High Flight Aero Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "High Flights Soaring Club",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "High Plains Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Highway Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hill Country Flyers",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hill Flying Club",
    state: "Utah",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hillsboro Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hobbs Soaring Society",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hokie Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hoosier Seneca Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hostess City Aviators, Inc.",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hub City Flying Club",
    state: "South Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hudson Valley Eagles",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Hudson Valley Hornets",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Huntsville Soaring Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Icon Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Idaho Skyriders",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "IFR Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Illini Glider Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Illinois Valley Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Illowa Sport Flyers",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Independence Youth Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Indian River Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Indy Aviators",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Indy Flyers",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Infinity Aero Club Tampa Bay, Inc",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Inn Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Instrument Trainer Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "International Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Intrepid Red Barons, Inc.",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Iosco Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Iroquois Soaring Association",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Jack Dunn Flying Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "JayCee Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "JB Aviation Flight Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "JCP Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Jeppesen Employees Flying Association",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Jersey Aero Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Joplin Flyers Inc.",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "K.State Flying Club, Inc",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kansas City Jet Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kansas Soaring Association",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "KC Eagles Soaring Club",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kendallville Soaring Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kennebec Flying Club Inc.",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Key City Fliers",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Keystone Flyers",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Keystone Taildraggers",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kingdom Flyers, Inc.",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kiss the Sun Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kitsap Aviation Squadron",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kittyhawk Squadron 3",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Klamath Basin Flyers",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Knik Flying Club",
    state: "Alaska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Knox County Flying Club",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Knoxville Flyers, Inc.",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Kootenai Flying Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "KPMP Area Club In Formation",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "KTKV Flyers, Inc.",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "KUZA Flyers, LLC",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "L.A Pilots Club",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "L35 Flyers LLC",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "La Porte Aero Club Inc",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lafayette Aero Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lago Vista Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lake Country Flying Club, Inc.",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lake Shelbyville Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lakes Region Flying Club, Inc.",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lakeway Flying Club (Closed)",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lancaster SR22 Fliers",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Land of Lincoln Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Land.O.Lakes Flying Club, Inc.",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lantana Beach Flyers",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Las Cruces Aviators",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Las Vegas Valley Soaring Association",
    state: "Nevada",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Laughing Bovine Flying Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Laurel Highlands Aviators",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "LC Valley Flying Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "LC Valley Flying Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Leading Edge Aviation Foundation",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Leading Edge Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Leadville Flying Club",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lebanon Flying Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ledge Aero",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Legacy Flying Club, Inc",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Legion Flying Club, Inc.",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lehigh Valley Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "LeMay Flight Training Center (Offutt Aero Club)",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lemoore Navy Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lenoir Aviation Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lexington Flying Club",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "LGE Flying Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lima Whiskey Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Live Free and Fly ,",
    state: "NH",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Living the Dream Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lockhart Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Long Island Soaring Association",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Loudoun Aviator Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Louisville Pilots' Club, Inc.",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Louisville Soaring Club",
    state: "Kentucky",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Low Flying Angels",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lowcountry Flying Club",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lowcountry Soaring Association",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Lower Keys Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mach 1 Flying Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Macon Flying Club, Inc.",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Macoupin Flyers Inc.",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Madera County Aircrafters",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Madison Aero Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Magic Valley Aero Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Main Line Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "MANG Aero Club, Inc.",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Manhattan Flying Tigers",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Manitowoc Flyers Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mankato Aviation Service Inc.",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "March Aero Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Marfa Gliders",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Marion Pilot's Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Marquette County Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mars Flying Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Marshall County Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Marshall Soaring Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mason County Aero Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Maui Flying Club",
    state: "Hawaii",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Meadville Aero Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Memphis Navy Flying Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Memphis Soaring Society",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mercer Aviators",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Merlin Soaring Association, Inc.",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Merritt Island Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mesquite Metro Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Metro Flyers Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mets Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Miami Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Michiana Air Activities",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mid Island Pilot's Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mid.Atlantic Soaring Association",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mid.Florida Right Flyers",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mid.Georgia Soaring Association",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mid.Tenn Aero Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Middle Tennessee Flying Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Middlebury Flying Club",
    state: "Vermont",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Midway Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Midwest National Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Midwestern Soaring Association",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mighty Mule Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Milco Airways Flying Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Miles City Flying Club",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mineral Wells Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Minnesota Soaring Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mississippi State University Soaring Club",
    state: "Mississippi",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mitanette Cooper Social Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mitchell Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Moccasin Flying Club",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mockingbird Flying Club",
    state: "South Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mohawk Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mohawk Soaring Club, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Molly Malone Flying Club",
    state: "New Mexico",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Monmouth Area Flying Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Monmouth Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Monterey Navy Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Monticello Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Morgantown Aero Corporation",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Morris Aero Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mount Washington Soaring Association",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mountain Flyers, Inc.",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mountain One Fliers",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Mountaineer Thunder Aero Club",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Muskogee Airmen, Inc",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Myrtle Beach Aero Club",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "N1708T Owners Association",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "N2785U Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "N7YM LLC",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Naper Aero Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Naperville Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Naples Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "NASAIRS Flight Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Nashua XC Flyers",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Nate Abel Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "NC86 Flying Club, Inc.",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "NEFC, Inc.",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Neo",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Nevada Soaring Association",
    state: "Nevada",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "New Braunfels Flying Club Inc",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "New Century Flyers",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "New England Soaring Association",
    state: "Vermont",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "New Hampshire Flying Association",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "New River Flying Club",
    state: "West Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Newton Flying Club",
    state: "Mississippi",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Nicollet Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "No Limits Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "NorCal Flight Club, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Carolina Soaring Association",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Carolina Soaring Association",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Coat Lite Flyers",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Florida Soaring Society",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Island Navy Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Perry Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Shore Aero Club",
    state: "Massachussetts",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Star Flyers Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "North Texas Soaring",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northeast Florida Aero Club, Inc",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northeast Nebraska Aviators, Inc.",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northeastern Oregon Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northern California Soaring Association",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northern Colorado Flying Club",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northern Maine Flying Club",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northern Virginia Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northwest Flyers",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northwest Flyers, Inc",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northwest Flyers, Inc.",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northwest Soaring Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northwind Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Northwind Flying Club",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "NRI Flying Club, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "NRV Flyers, Inc",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Nutmeg Soaring Association",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Oak Ridge Flyers, Inc.",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ocmulgee River Aviators",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Octopus Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Octopus Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Odyssey Aero Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Oklahoma Airmen Flying Club",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Oklahoma Soaring Association",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Okoboji Flyers, LLC",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Olds Forge Flyers, Inc.",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Omaha Soaring Club",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "One Fifty Club, Inc.",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "ORANGE COUNTY FLYERS, INC",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Oregon Outback Aviators",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Oregon State Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Orlando Aero Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Orlando Aviators Flying Club, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Orlando Christian Flying Club, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Orlando Sanford Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "ORLANDO SANFORD FLYING CLUB",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Oxford Flying Club, Inc.",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Oxnard Aero Flying Club, Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ozark Aviators, Inc.",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pacca Club Inc.",
    state: "Rhode Island",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pacific Coast Flyers",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pacific Gold Aviation Association",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pactola Flying Club",
    state: "South Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pal Day Aero Club, Inc.",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Palm Springs Aviators",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "PanAir Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Panhandle Flyers",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Paramus Flying Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Park Forest South Aviation Group",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Patuxent River Navy Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Payson Aero Club, LLC",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pelican Flying Club, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Penn Ohio Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Penn State Soaring Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Penn Valley Pilots Organization",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Penn Yan Flying Club, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pensacola Navy Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Perkins Field Flying Club",
    state: "Nevada",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "PGA WEST FLYING CLUB",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Phantom Five, Inc. Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Philadelphia Glider Council",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Phoenix Club Soaring",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Phoenix Flyers, Inc",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Phoenix Flying Club, Inc.",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Piasa Flyers Aero Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "PIC Flying Club, LLC",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Piedmont Aero Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Piedmont Soaring Society",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pikes Peak Fliers",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pilot Partner Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pineapple Flyers Inc",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pinellas Pilots Association",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pineywoods Flyers",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pinion Aviation",
    state: "Nevada",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pirate Aviation, LLC",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pittsburg Flying Club, Inc.",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pittsburgh Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pittsburgh Soaring Association",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Plane Fun Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Plymouth Flying Club, Inc.",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "PML Aero Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pocono Mountains Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pompano Senior Squadron Flying Club Inc",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ponderosa Aero Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Portage Valley Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Portsmouth Flying Club",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Post Mills Soaring Club",
    state: "Vermont",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pottstown Aircraft Owners & Pilots",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Precision Aero club",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Prescott Area Soaring",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Prescott Flying Club, Inc.",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Prestige Worldwide Aviation",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Princeton Flying Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Princeton Raptors Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Prineville Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Propel Aero Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Pryor Flying Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Puget Sound Flyers, NP",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Puget Sound Soaring Association",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Purdue Pilots, Inc.",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Quad City Area Flying Eagles, Inc.",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Quantico Marine Corps Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Quarter to Two Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Queen City Aero Club",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "QwikFlights Flying Club",
    state: "Utah",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Raider Pilots Association",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rangers Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rapid Flyers",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rawlins Flying Club",
    state: "Wyoming",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Reading Aero Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red Baron Flyers, Inc.",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red Baron Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red Cub",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red Dirt Aviators Flying Club",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red Lodge Flying Club",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red River Aviators",
    state: "Louisiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red River Flyers",
    state: "North Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red Wing Soaring Association",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Red.tailed Hawks / Black Pilots of America, Inc.",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Redbird Flight & Social Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Redlands Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rescue Cessna 150 Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Resort Region Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "RFC Dallas, Inc.",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "RI Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rialto Christian Flyers Club, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Richmond Pilots",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rio Aero Club, Inc.",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rising Aviation Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "River City Aero Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "River City Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "River City Flying Club, Inc",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Riverland Flyers",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Riverside Pilots Flying Club, Inc",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Robins AFB Aero Club",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rochester Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rock River Flying Inc.",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rockdale Flying Tigers",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rockwell Flying Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rogue Valley Flying Club",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rose City Soaring Association",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "RPM Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Rutherford County Flying Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sabetha Flyers, Inc.",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Salem Aero Club",
    state: "Delaware",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Salem Pilots Association",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "San Juan Flying Club",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sandhill Soaring Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sanford Soaring Club",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Santa Barbara Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sarasota SeaBreeze Flyers, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sarasota Westwind Flyers, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Saratoga Flyers, Inc.",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Saratoga Soaring Association",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Saunders County Flying Club Inc",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "SCAC (Sun Country Aero Club)",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Schaumburg Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Schodack Aviation Association, Inc",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Scottsdale Flying Club",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Seagull Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sedona Flying Club",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Seeley Lake",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Seven Delta Whiskey",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Shamrock Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Shearline Aero",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Shen Air II",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Shenandoah Valley Soaring",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Shenandoah Valley Soaring",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Shortway Pilots, Inc.",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Shreveport Soaring Club",
    state: "Louisiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "SideSlip Aviation",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sierra Soaring Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Silent Knights Glider Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Silver City Flying Club",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Silverado Soaring Club",
    state: "Nevada",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Silvercreek Glider Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skiatook Flying Club",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky Bryce Flying Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky Knights Flight Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky Pilot Aero Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky Roamers, LLC",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky Soaring Glider Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky's The Limit Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky's The Limit Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sky",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skycombers Flying Club Inc.",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skycrafters",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyhaven Flying Club, Inc",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyhawk Five",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyhawk Flying Club",
    state: "Nebraska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyhawk Flying Club Inc",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyhawks, Inc",
    state: "Wisconsin",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "SkyHawks, Inc.",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skylarks Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyline Soaring Club",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skymaster Shares.com",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skypark Aero Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyraider Aero Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skyriders Flying Club, Inc",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Skywagon Flying Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sleeping Giant Flying Club",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Smoke Eagles",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Smokehouse Pilots",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Smoketown 150 Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Smoky Mountain Flying Club",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Smoky Mountain Soaring Association",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Smooth Sailing Flying Club Inc.",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "SnoFly",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Snoopy's Group, Inc.",
    state: "Rhode Island",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Soar Indy",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Soaring Club of Houston Inc.",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Soaring Society of Boulder",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Soaring Sooners, Inc.",
    state: "Oklahoma",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Soaring Thunderbirds",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Soaring Tigers",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Socata Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Solar Flying Club",
    state: "Iowa",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Soldotna Flying Club (Club in Formation)",
    state: "Alaska",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sons O'GOD Flying Club",
    state: "Arizona",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sopwith Camel Flying Club",
    state: "Utah",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South Alabama Flying Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South Alabama Flying Club",
    state: "Alabama",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South County Flyers Inc.",
    state: "Rhode Island",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South Jersey Aero Club (SOJAC)",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South Mountain Flying Club Inc",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South Shore Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South Side Soaring Glider Club",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "South Whidbey Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Southeast CT Flying Club",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Southeastern Minnesota Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Southern Eagles Soaring",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Southgate Flying Club",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Southwest Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spa City Flyers",
    state: "Arkansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spinner Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spirit Flyers, Inc.",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spirit of Meriden Flight Club, Inc.",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spirit of St. Louis Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spirits of Aviation Flying Club, LLC",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Splendid Aviation Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spokane Soaring Society",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sporty's Flying Club",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Springfield Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Springville Flying Club",
    state: "Utah",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Spruce Creek Aviators",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "St. Louis Flying Club",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Star Mountain Aviation",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Starved Rock Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "State College Pilots Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Steamboat Flying Club, LLC",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Stick & Rudder Flying Club",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Stick & Rudder Flying Club",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Stillwater Flyers, LLC",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "STL Aviators, Inc.",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Stockbridge Valley Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Stoddard County Flyers",
    state: "Missouri",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sugarbush Soaring Association",
    state: "Vermont",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sumter Aero Club, inc",
    state: "North Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Suncoast Flyers, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sundowners, Inc.",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Sunrise Flying Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Superhawk Inc",
    state: "Utah",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Swamp Creek Flyers",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Swift Arrow Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "SWLA Aviation, LLC",
    state: "Louisiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Symonds Aviation",
    state: "Illinois",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Syracuse Flying Club",
    state: "New York",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "T.Craft Aero Club",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tabooma Flyers, Inc.",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tahoe Flying Club, Inc.",
    state: "california",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tail Dragger Flyers",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Taildraggers, Inc.",
    state: "South Dakota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tailwinds",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tailwinds Flying Club",
    state: "Minnesota",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tampa Bay Soaring Society",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "TC CAVU Flying Club, LLC",
    state: "Michigan",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tech Flight Corp",
    state: "Maine",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Ten.Hi Flyers",
    state: "Colorado",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tennessee Flyers",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Terrell Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Texas Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Texins Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Texoma Aero Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The 150th Aero Flying Club, Inc.",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The 150th Aero Flying Club, Inc.",
    state: "New Jersey",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Airplane Club",
    state: "California",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Bluff City Flyers Flying Club, Inc.",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Citadel Flying Club",
    state: "South Carolina",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Flying 64th",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Flying Club, Inc.",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Flying Neutrons, LLC",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Flying Signaleers,",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Flying Yankees",
    state: "New Hampshire",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Great Plains Balloon Club",
    state: "Kansas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The High Flying Club, Inc",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Litchfield Hills Aero Club, LLC",
    state: "Connecticut",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Mentone Flying Club, Inc.",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Mineral County Flying Club Inc.",
    state: "Nevada",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "The Salisbury Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Thompson Flying Club",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Thoroughbred Flying Club",
    state: "Indiana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Three Forks Flying Club, Inc.",
    state: "Montana",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Three Two Five Echo Flying Club",
    state: "Texas",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tidewater Flying Club, Inc.",
    state: "Virginia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tiger Flight Foundation",
    state: "Georgia",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tiger Flying Club",
    state: "Maryland",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Tillamook Pilots Association",
    state: "Oregon",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Titusville Aero Club Inc.",
    state: "Pennsylvania",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Titusville Flying Club",
    state: "Florida",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Toledo Buzzards Light Sport Aircraft Club, Inc",
    state: "Ohio",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Toledo Flying Club",
    state: "Washington",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Top Fun Flyers",
    state: "Idaho",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "TopFlight Aviation",
    state: "Tennessee",
    type: "flying_clubs",
    country: "United States",
  },
  {
    name: "Torrington Flying Club",
    state: "Wyoming",
    type: "flying_clubs",
    country: "United States",
  },
];

export const BusinessFragment = () => {
  const { type } = useParams();
  const [businesses, setBusinesses] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // Single search field state
  const [loading, setLoading] = useState(false); // Single search field state

  console.log({ type });
  const fetchBusinesses = useCallback(async () => {
    try {
      setLoading(true);

      // If type is 'flying_clubs', use static data instead of API call
      if (type === "flying_clubs") {
        // Filter static data based on search query if any
        let filteredData = staticRecords;
        if (searchQuery.trim()) {
          filteredData = staticRecords.filter(
            (business) =>
              business.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
              business.state
                .toLowerCase()
                .includes(searchQuery.toLowerCase()) ||
              business.country.toLowerCase().includes(searchQuery.toLowerCase())
          );
        }
        setBusinesses(filteredData);
        setLoading(false);
        return;
      }

      // For other types, fetch from API as before
      const { data } = await getBusinesss({
        type,
        search: searchQuery,
        limit: 2000,
      });
      setBusinesses(data);
      setLoading(false);
      // console.log("Fetched Business Data:", data); // Uncomment to inspect the data structure
    } catch (error) {
      console.error("Error fetching businesses:", error);
      setLoading(false);
    }
  }, [searchQuery, type]);

  // Trigger fetch on page load
  useEffect(() => {
    fetchBusinesses();
  }, [fetchBusinesses]);

  // Group Businesses  by country and then by state
  const groupByCountryState = () => {
    const groupedData = {};

    businesses.forEach((business) => {
      const { country, state } = business;
      if (!groupedData[country]) {
        groupedData[country] = {};
      }
      if (!groupedData[country][state]) {
        groupedData[country][state] = [];
      }
      groupedData[country][state].push(business);
    });

    return groupedData;
  };

  const groupedBusinesses = groupByCountryState();

  const handleSearch = () => {
    fetchBusinesses(); // Trigger the fetch with the current search query
  };

  return (
    <Layout>
      {loading ? (
        "Loading the data, please wait. it can take time...."
      ) : (
        <div className="bg-white">
          {/* Single Search Field and Button */}
          <div className="flex justify-center gap-3 p-4">
            <input
              type="text"
              className="form-control !w-1/3"
              placeholder="Search for a business by name, airport, country, or state..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update search query
            />
            <button
              className="btn btn-primary"
              onClick={handleSearch} // Trigger the search when button is clicked
            >
              Filter
            </button>
          </div>
          <section
            style={{ backgroundColor: "#f6f8fa" }}
            id="sec1"
            data-scrollax-parent="true"
          >
            <div className="container">
              <div
                style={{ paddingTop: "50px", color: "#3B4249" }}
                className="section-title"
              >
                <h2 className="!text-left">
                  {
                    type === "cfis"
                      ? "CFIs" // Special case for "cfis"
                      : type.includes("_") && type.split("_").length > 2
                      ? type
                          .replace(/_(?=[^_]*$)/, " / ") // Replace the last underscore with a space and a slash
                          .replace(/_/g, " ") // Replace all other underscores with spaces
                          .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                      : type
                          .replace(/_/g, " ") // If there's only one underscore, replace it with space
                          .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                  }
                </h2>

                <p
                  className="!text-left"
                  style={{ fontSize: "15px", color: "#3B4249" }}
                >
                  {type !== "shopping"
                    ? `Browse your favorite ${
                        type === "cfis"
                          ? "CFIs" // Special case for "cfis"
                          : type.includes("_") && type.split("_").length > 2
                          ? type
                              .replace(/_(?=[^_]*$)/, " / ") // Replace the last underscore with a space and a slash
                              .replace(/_/g, " ") // Replace all other underscores with spaces
                              .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                          : type
                              .replace(/_/g, " ") // If there's only one underscore, replace it with space
                              .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
                      }`
                    : "Shop for your favorite Products"}
                  &nbsp; .
                </p>
              </div>

              {/* Loop through grouped data */}
              <div className="my-8 about-wrap">
                <div
                  style={{ display: "flex", flexWrap: "wrap" }}
                  className="row"
                >
                  {Object.keys(groupedBusinesses).map((country) => (
                    <div key={country} className="col-md-12">
                      {" "}
                      {/* Full width for country heading */}
                      <div style={{ paddingLeft: "0px" }} className="ab_text">
                        <div className="ab_text-title fl-wrap">
                          <h3
                            style={{
                              marginBottom: "15px",
                              color: "#3B4249",
                              textDecoration: "underline",
                            }}
                          >
                            {country}
                          </h3>
                          {Object.keys(groupedBusinesses[country])
                            .sort()
                            .map((state) => (
                              <div
                                key={`${country}-${state}`}
                                className="col-md-3 !mr-0 !ml-0"
                                style={{
                                  display: "inline-block",
                                  verticalAlign: "top",
                                  // Added some margin for visual separation between states
                                  marginRight: "20px",
                                  marginBottom: "20px",
                                }}
                              >
                                {" "}
                                {/* Adjust width for states */}
                                <h4
                                  style={{
                                    marginBottom: "10px",
                                    color: "#3B4249",
                                    textDecoration: "underline",
                                    fontSize: "18px", // Slightly smaller for state
                                  }}
                                >
                                  {state}
                                </h4>
                                {groupedBusinesses[country][state].map(
                                  (business) => {
                                    console.log("Business:", business);

                                    const imageUrl = `https://s3.amazonaws.com/flyinn-app-bucket/${business.business_logo}`;
                                    return (
                                      <div
                                        key={business.restaurant_id}
                                        style={{ marginBottom: "15px" }}
                                      >
                                        <Link
                                          to={`/business/${type}/${business?.business_id}`}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            textDecoration: "none",
                                          }}
                                        >
                                          {business.business_logo ? ( // Conditionally render image if it exists
                                            <img
                                              src={imageUrl} // Use the image property from the business object
                                              alt={business.name}
                                              style={{
                                                width: "50px", // Adjust size as needed
                                                height: "50px", // Adjust size as needed
                                                marginRight: "10px",
                                                borderRadius: "5px", // Optional: rounded corners
                                                objectFit: "cover", // Ensures the image covers the area
                                              }}
                                            />
                                          ) : (
                                            <i
                                              className={`fa ${
                                                DEFAULT_TYPE_ICONS[type] ||
                                                DEFAULT_TYPE_ICONS.default
                                              } text-5xl`}
                                            ></i>
                                          )}
                                          <p
                                            className="!m-0 flex flex-col"
                                            style={{
                                              fontSize: "16px",

                                              color: "#3B4249",
                                            }}
                                          >
                                            <span className="">
                                              {business.name}
                                            </span>
                                            {business?.distance_from_runway && (
                                              <small>
                                                {`${business?.distance_from_runway} miles away from ${business?.airport}`}
                                              </small>
                                            )}
                                          </p>
                                        </Link>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </Layout>
  );
};
